import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useTheme,
  Button,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { ColorModeContext, tokens } from '../../theme';
import LogoutIcon from '@mui/icons-material/Logout';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { useNavigate } from 'react-router-dom';
import ChangeAdminPassword from './ChangeAdminPassword';

const Topbar = ({ setMobileOpen = () => {} }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const [adminUser, setAdminUser] = useState({ username: '', email: '' });
  const [anchorEl, setAnchorEl] = useState(null);
  const [passwordOpen, setPasswordOpen] = useState(false);
  const open = Boolean(anchorEl);

  useEffect(() => {
    // Get admin user data from localStorage (set by Sidebar component)
    const adminUserStr = localStorage.getItem('adminUser');
    if (adminUserStr) {
      try {
        const user = JSON.parse(adminUserStr);
        setAdminUser({
          username: user.username || '',
          email: user.email || '',
        });
      } catch (e) {
        console.error('Error parsing admin user from localStorage', e);
      }
    }
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/admin/login');
  };

  // Get initial letter for avatar
  const getInitial = () => {
    if (adminUser.username) {
      return adminUser.username.charAt(0).toUpperCase();
    }
    return 'A';
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" px={2} pt={2}>
      <IconButton
        sx={{ display: { md: 'none' }, mr: 'auto', ml: -1 }}
        onClick={() => setMobileOpen(true)}
      >
        <MenuOutlinedIcon />
      </IconButton>
      <Tooltip title="Account">
        <Button
          variant="text"
          onClick={handleClick}
        >
          <Avatar
            sx={{
              bgcolor: colors.blueAccent[500],
              color: colors.grey[100],
              width: 40,
              height: 40,
              fontWeight: 'bold',
              fontSize: '18px',
            }}
          >
            {getInitial()}
          </Avatar>
          {adminUser.username && (
            <Box ml={1}>
              <Typography variant="body2" fontWeight="bold" color={colors.grey[100]}>
                {adminUser.username}
              </Typography>
            </Box>
          )}
        </Button>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 200,
            backgroundColor: colors.primary[400],
            '& .MuiMenuItem-root': {
              color: colors.grey[100],
              '&:hover': {
                backgroundColor: colors.primary[500],
              },
            },
          },
        }}
      >
        {adminUser.username && (
          <MenuItem disabled>
            <Typography variant="body2" fontWeight="bold">
              {adminUser.username}
            </Typography>
          </MenuItem>
        )}
        {adminUser.email && (
          <MenuItem disabled>
            <Typography variant="body2" color={colors.grey[300]}>
              {adminUser.email}
            </Typography>
          </MenuItem>
        )}
        {(adminUser.username || adminUser.email) && <Divider sx={{ my: 1, bgcolor: colors.grey[700] }} />}
        <MenuItem
          onClick={() => {
            handleClose();
            setPasswordOpen(true);
          }}
        >
          <LockResetOutlinedIcon sx={{ mr: 1, fontSize: 20, color: colors.blueAccent[500] }} />
          <Typography>Change Password</Typography>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <LogoutIcon sx={{ mr: 1, fontSize: 20, color: colors.redAccent[500] }} />
          <Typography>Logout</Typography>
        </MenuItem>
      </Menu>
      <ChangeAdminPassword open={passwordOpen} handleClose={() => setPasswordOpen(false)} />
    </Box>
  );
};

export default Topbar;
